/** Rota da LP B2B (mesmas âncoras de seção da home e /simular). */
export const B2B_LANDING_PATH = "/empresas" as const

export function isB2BLandingPath(pathname: string | null | undefined): boolean {
  return pathname === B2B_LANDING_PATH
}

export const B2B_CADASTRO_HREF = "/cadastro?personType=pj"
